module.exports = __webpack_public_path__ + "static/scale-model-of-expedition-tanzania-in-tucson-arizona-538cb58dd5326a864638c10e70b09b8f.png";